import { getEffectivePrinterLinkSettings, getStoredPrinterModelId } from '../printerModelConfig';
import { getPrinterPowerSettings } from '../printerPowerSettings';
import { getXpP203aBluetoothTransport } from '../xpP203aBluetoothTransport';
import { getXpP203aLabelConfig, shouldUseXpP203aTspl, MIN_XP_P203A_PRINT_WIDTH_MM } from '../xpP203aLabelConfig';
import type { PayzheBtpSettingsPayload } from './types';

export function buildPayzheBtpSettingsPayload(): PayzheBtpSettingsPayload {
  const link = getEffectivePrinterLinkSettings();
  const power = getPrinterPowerSettings();
  const xpTransport = getXpP203aBluetoothTransport();
  const label = getXpP203aLabelConfig();
  return {
    modelId: getStoredPrinterModelId(),
    transport:
      xpTransport === 'ble'
        ? 'ble'
        : xpTransport === 'bluetooth-serial'
          ? 'classic-serial'
          : 'auto',
    autoPowerOffMinutes: power.autoPowerOffMinutes,
    keepAliveEnabled: power.bleKeepAliveEnabled,
    keepAliveIntervalMs: 45_000,
    tsplMode: shouldUseXpP203aTspl(link.modelId),
    escposMode: !shouldUseXpP203aTspl(link.modelId),
    labelWidthMm: Math.max(MIN_XP_P203A_PRINT_WIDTH_MM, label.widthMm),
    labelHeightMm: label.heightMm,
    paperWidthMm: Math.max(MIN_XP_P203A_PRINT_WIDTH_MM, label.widthMm),
    reconnectEnabled: true,
    autoRestorePrinter: true,
    wakeLockEnabled: true,
  };
}
